import "./styles.scss";

import { useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { ReactComponent as EyeIcon } from "assets/icons/new/eye.svg";

const mainClass = "input";

const Input = ({
  type = "text",
  label,
  placeholder,
  name,
  touched,
  error,
  value,
  onChange,
  disabled,
  uppercaseLabel = false,
  maxLength,
  required,
  id,
  readOnly,
}) => {
  const { t } = useTranslation();
  const [show_password, setShowPassword] = useState(false);

  const Tag = type === "textarea" ? "textarea" : "input";

  const is_error = touched && error !== undefined;

  return (
    <div
      id={id}
      className={classnames(mainClass, {
        [`${mainClass}--error`]: !!is_error,
        [`${mainClass}--uppercase-label`]: !!uppercaseLabel,
        [`${mainClass}--read-only`]: !!readOnly,
      })}
    >
      {!!label && (
        <label>
          {label}
          {!!required && <span>*</span>}
        </label>
      )}
      <div className={`${mainClass}__content`}>
        <Tag
          className={`${mainClass}__field`}
          type={!!show_password ? "text" : type}
          placeholder={placeholder}
          value={value}
          name={name}
          onChange={onChange}
          disabled={disabled}
          maxLength={maxLength}
          readOnly={readOnly}
        />
        {type === "password" && (
          <button
            type="button"
            className={classnames(`${mainClass}__content__show-password`, {
              [`${mainClass}__content__show-password--active`]: !!show_password,
            })}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            <EyeIcon />
          </button>
        )}
      </div>
      {!!is_error && (
        <small className={`${mainClass}__error`}>{t(error)}</small>
      )}
    </div>
  );
};

export default Input;
